import { render, staticRenderFns } from "./AyudaParte2Acopio.vue?vue&type=template&id=0d0f1eb9&scoped=true"
import script from "./AyudaParte2Acopio.vue?vue&type=script&lang=js"
export * from "./AyudaParte2Acopio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0f1eb9",
  null
  
)

export default component.exports